import React from "react";
import { Col } from "react-bootstrap";
import { Link, useNavigate, useParams } from "react-router-dom";

export default function CountCardComponent({ data, formState }) {

	const navigate = useNavigate();


	const handleCardClick = (key) => {
		formState.key = key;
		navigate(`/dashboard-count-list`, { state: formState });

	};
	const floats = [
		{
			key: "total_slave_born",

			title: "Total Born Slave Rescued",
			digit: data?.total_slave_born,
			icon: "price_check",
			variant: "lg red",
		},
		{
			key: "total_baby_rescued",

			title: "Total Teenage Children",
			digit: data?.total_baby_rescued,
			icon: "price_check",
			variant: "lg blue",
		},
		{
			key: "total_adult_rescued",
			title: "Total Youth Rescued",
			digit: data?.total_adult_rescued,
			icon: "settings_accessibility",
			variant: "lg green",
		},


		{
			key: "total_abused_families",

			title: "Total Abused Families",

			digit: data?.total_abused_families,
			icon: "settings_accessibility",
			variant: "lg blue",
		},
		{
			key: "total_families_rescued",
			title: "Total Count of Slaves",
			digit: data?.total_slaves,
			icon: "price_check",
			variant: "lg blue",
		},
		{
			key: "total_families_rescued",
			noclick: true,
			title: "Average Count of Slaves",
			digit:
				data?.total_families_rescued > 0
					? Math.round(
						data?.total_slaves / data?.total_families_rescued
					)
					: 0,
			icon: "price_check",
			variant: "lg blue",
		},
		{
			key: "total_slavery_years",
			title: "Total Years of Slavery",
			noclick: true,
			digit: data?.total_slavery_years,
			icon: "price_check",
			variant: "lg blue",
		},
		{//here key is not set yet
			key: "total_families_rescued",
			title: "Average Years of Slavery",
			noclick: true,
			digit:
				data?.total_families_rescued > 0
					? Math.round(
						data?.total_slavery_years /
						data?.total_families_rescued
					)
					: 0,
			icon: "price_check",
			variant: "lg blue",
		},
		{
			key: "total_followups",

			title: "Total Follow-ups",
			digit: data?.total_followups,
			icon: "emoji_flag",
			variant: "lg blue",
		},
		{
			key: "total_family_followups",
			title: "Families with Follow-Up Status",

			digit: data?.total_family_followups,
			icon: "outlined_flag",
			variant: "lg blue",
		},
		{
			key: "total_not_followups",
			title: "Families Not Follow Up",

			digit: data?.total_not_followups,
			icon: "do_not_disturb",
			variant: "lg blue",
		},
		{
			key: "total_baptized",
			title: "Total Baptized",

			digit: data?.total_baptized,
			icon: "water",
			variant: "lg blue",
		},
		{
			key: "school_going_children",
			title: "Children Going School",

			digit: data?.school_going_children,
			icon: "directions_bus",
			variant: "lg blue",
		},
		{
			key: "eligible_but_not_school_going",
			title: "Eligible But Not Going School",

			digit: data?.eligible_but_not_school_going,
			icon: "no_transfer",
			variant: "lg blue",
		},
		{
			key: "total_voc_trainings",
			title: "Vocational Training Admissions",

			digit: data?.total_voc_trainings,
			icon: "dvr",
			variant: "lg blue",
		},
		{
			key: "total_business_granted",
			title: "Total Business Granted",

			digit: data?.total_business_granted,
			icon: "business_center",
			variant: "lg blue",
		},
		{
			key: "total_families_rescued",
			title: "Budget Expenditure",

			digit: data?.total_budget_expenditure,
			icon: "monetization_on",
			variant: "lg blue",
		},
		{// here key is not set yet
			noclick: true,
			key: "Average-Debt-Per-Family",
			title: "Average Debt Per Family",

			digit: data?.total_loan_paid > 0
				? Math.round(
					data?.total_loan_paid / data?.total_families_rescued
				)
				: 0,
			icon: "monetization_on",
			variant: "lg blue",
		},
	];
	return (
		<>
			{floats.map((data, index) => {
				return (
					<Col
						key={index}
						sm={6}
						lg={4}
					>
						<div

							onClick={data.noclick ? null : () => handleCardClick(data.key)}
							className={`mc-float-card ${data.variant}`}
							style={{
								background:
									"linear-gradient(to right, rgba(0,0,0,0.8), #077834)",
								cursor: data.noclick ? "default" : "pointer",
							}}
						>
							<h3>{data.digit}</h3>
							<p>{data.title}</p>
							<i
								className="material-icons"
								style={{ color: "#077834" }}
							>
								{data.icon}
							</i>
						</div>
					</Col>
				);
			})}
		</>
	);
}
